import { Box, Button, Card, TextField, Typography } from "@mui/material";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Form, Modal } from "react-bootstrap";
import logo from "../../assets/img/XC_Helpdesk.svg";
import { endpointPrincipal } from "../../api/endPoints/endpointPrincipal/endpointPrincipal";
import { AxiosError } from 'axios';
import { setSessionData } from "../../utils/storageUtils";
import { FUNCAO_PAINEL_TV, PERFIL_PAINEL_TV } from "../../types/PermissaoInterface";
import FormActions from "../../components/Formularios/Buttons/FormActions";

// Campos com fundo branco e contorno cinza (mesmo padrão do login do XC WMS)
const estiloCampo = {
  "& .MuiOutlinedInput-root": {
    color: "#000",
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "#888" },
    "&:hover fieldset": { borderColor: "#666" },
    "&.Mui-focused fieldset": { borderColor: "#000" },
    "& input:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #fff inset",
      WebkitTextFillColor: "#000",
    },
  },
  "& .MuiInputLabel-root, & .MuiInputLabel-root.Mui-focused": { color: "#000" },
};

export function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [senha, setSenha] = useState<string>("");
  const [entrando, setEntrando] = useState(false);
  const emailRef = useRef<HTMLInputElement>(null);
  //#region ===> VALIDAR LOGIN
  const login = async (email: string, password: string) => {
    const dados = {
      email: email,
      senha: password,
    };

    setEntrando(true);
    try {
      const response = await endpointPrincipal.post("/auth/login", dados);
      const { token } = response.data;

      // Decodificar o token JWT (payload)
      const payload = JSON.parse(atob(token.split('.')[1]));

      const perfil =
        payload.funcao === FUNCAO_PAINEL_TV
          ? PERFIL_PAINEL_TV
          : payload.funcao === "Usuario"
            ? "usuario"
            : "agente";

      setSessionData("xc-helpdesk-token", token);
      setSessionData("DadosUsuario", payload.nome_usuario);
      setSessionData("EmailUsuario", payload.email);
      setSessionData("DadosUsuarioID", String(payload.id_usuario));
      setSessionData("PerfilUsuario", perfil);
      setSessionData("isPerfilSuper", payload.funcao === 'Administrador' ? "true" : "false");
      setSessionData("NomeUsuario", payload.nome_usuario);

      if (perfil === PERFIL_PAINEL_TV) {
        localStorage.removeItem("redirectPath");
        window.location.href = "/kpi/dashboard/paineldecontrole";
        return;
      }

      // Verificar se há um caminho de redirecionamento salvo diretamente no localStorage
      const redirectPath = localStorage.getItem('redirectPath');
      if (redirectPath) {
        localStorage.removeItem('redirectPath'); // Limpar o caminho salvo diretamente do localStorage
        window.location.href = redirectPath; // Redirecionar para o caminho salvo
      } else {
        // Redirecionar para o painel de controle padrão
        window.location.href = '/kpi/dashboard/paineldecontrole';
      }

    } catch (erro: unknown) {
      const axiosError = erro as AxiosError<{message: string}>;
      const msg = axiosError.response?.data?.message || axiosError.message;
      toast.error(`Falha ao realizar login. Motivo: ${msg}`);
      setEntrando(false);
      emailRef.current?.focus();
    }
  };

  useEffect(() => {
    // Se SKIP_AUTH estiver ativo, redireciona direto para a página principal
    if (process.env.REACT_APP_SKIP_AUTH === 'true') {
      navigate("/");
    }
  }, []);

  //#endregion
  const enviar = (event: any) => {
    event.preventDefault();
    login(email, senha);
  };

  ///PARTE DE REDEFINIÇÃO DE SENHA///

  //controle modal recSenha
  const [showModalRecSenha, setshowModalRecSenha] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [EmailRec, setEmailRec] = useState("");

  function abrirModalRecSenha() {
    setEmailRec("");
    setIsSubmitting(false);
    setshowModalRecSenha(true);
  }

  async function enviarSolicitacaoRecuperacao(e: React.FormEvent) {
    e.preventDefault();

    if (!EmailRec || EmailRec.trim() === "") {
      toast.error("Por favor, insira um email válido");
      return;
    }

    setIsSubmitting(true);

    try {
      await endpointPrincipal.post("/auth/recuperar-senha", {
        email: EmailRec
      });

      toast.success("Se o e-mail existir em nosso sistema, você receberá as instruções de recuperação de senha");
      setshowModalRecSenha(false);
    } catch (error) {
      // Mensagem genérica para não revelar se o email existe
      toast.success("Se o e-mail existir em nosso sistema, você receberá as instruções de recuperação de senha");
    } finally {
      setIsSubmitting(false);
    }
  }

  function fecharModalRecSenha() {
    setshowModalRecSenha(false);
    setEmailRec("");
  }

  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        <Card
          elevation={6}
          sx={{
            width: "100%",
            maxWidth: 1280,
            borderRadius: 4,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#fff",
          }}
        >
          <Box sx={{ flex: 1, display: { xs: "block", md: "flex" } }}>
            {/* Logo grande (telas médias em diante) */}
            <Box
              sx={{
                flex: 1,
                display: { xs: "none", md: "flex" },
                justifyContent: "center",
                alignItems: "center",
                p: 4,
              }}
            >
              <img
                src={logo}
                alt="XC Help Desk"
                style={{ width: "100%", maxWidth: 420, height: "auto" }}
              />
            </Box>

            <Box
              sx={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: { xs: 3, sm: 6 },
              }}
            >
              <Card
                elevation={3}
                sx={{
                  width: "100%",
                  maxWidth: 520,
                  p: 4,
                  borderRadius: 3,
                  backgroundColor: "#fff",
                  color: "#000",
                }}
              >
                {/* Logo pequeno (telas pequenas) */}
                <Box
                  sx={{
                    display: { xs: "flex", md: "none" },
                    justifyContent: "center",
                    mb: 3,
                  }}
                >
                  <img
                    src={logo}
                    alt="XC Help Desk"
                    style={{ width: "100%", maxWidth: 240, height: "auto" }}
                  />
                </Box>

                <Typography variant="subtitle2" textAlign="center">
                  Efetue o login para acessar o sistema
                </Typography>

                <form onSubmit={enviar}>
                  <TextField
                    label="E-mail"
                    type="email"
                    fullWidth
                    margin="normal"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    inputRef={emailRef}
                    inputProps={{ required: true }}
                    sx={estiloCampo}
                  />

                  <TextField
                    label="Senha"
                    type="password"
                    fullWidth
                    margin="normal"
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    inputProps={{ required: true }}
                    sx={estiloCampo}
                  />

                  <Box sx={{ textAlign: "right" }}>
                    <Button
                      variant="text"
                      size="small"
                      onClick={abrirModalRecSenha}
                      sx={{ textTransform: "none", color: "#F38632" }}
                    >
                      Esqueceu sua senha?
                    </Button>
                  </Box>

                  <Button
                    type="submit"
                    fullWidth
                    disabled={entrando}
                    sx={{
                      mt: 2,
                      py: 1.2,
                      fontWeight: "bold",
                      background: "#F38632",
                      color: "#fff",
                      borderRadius: 50,
                      "&:hover": {
                        backgroundColor: "#ecab78",
                        color: "#fff",
                      },
                      "&.Mui-disabled": {
                        backgroundColor: "#ecab78",
                        color: "#fff",
                      },
                    }}
                  >
                    {entrando ? "ENTRANDO..." : "ENTRAR"}
                  </Button>
                </form>
              </Card>
            </Box>
          </Box>

          <Box
            sx={{
              textAlign: "center",
              py: 2,
              borderTop: "1px solid #e0e0e0",
            }}
          >
            <Typography variant="body2" color="#000">
              © 2021 - {new Date().getFullYear()} XC Soluções. Todos os
              direitos reservados.
            </Typography>
          </Box>
        </Card>
      </Box>

      {/*MODAL REC SENHA */}
      <Modal
        show={showModalRecSenha}
        backdrop="static"
        size="lg"
        keyboard={false}
        centered
      >
        <Modal.Header className="bg-white">
          <Modal.Title>Recuperação de Senha</Modal.Title>
        </Modal.Header>
        <Form onSubmit={enviarSolicitacaoRecuperacao}>
          <Modal.Body className="bg-white">
            <Typography variant="body2" sx={{ mb: 2 }}>
              Informe o e-mail cadastrado no sistema para receber um link de recuperação de senha.
            </Typography>
            <TextField
              label="E-mail"
              type="email"
              size="small"
              fullWidth
              autoFocus
              value={EmailRec}
              onChange={(e) => setEmailRec(e.target.value)}
              inputProps={{ required: true, style: { textTransform: "lowercase" } }}
              InputLabelProps={{ shrink: true }}
              sx={{ maxWidth: { sm: "50%" } }}
            />
          </Modal.Body>
          <Modal.Footer className="bg-white">
            <FormActions
              onVoltar={fecharModalRecSenha}
              labelVoltar="Cancelar"
              labelSalvar={isSubmitting ? "Enviando..." : "Enviar"}
              iconeSalvar={<SendOutlinedIcon />}
              salvarDisabled={isSubmitting}
              variante="modal"
            />
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
